<ngx-spinner bdColor="rgba(15, 38, 64, 0.95)" size="large" color="#f5a623" type="ball-scale-multiple"
    [fullScreen]="true">
    <div class="spinner-brand">
        <h2>AMT</h2>
        <p>Loading</p>
    </div>
</ngx-spinner>
<router-outlet></router-outlet>